// extracted by mini-css-extract-plugin
export default {"icon":"src-feature-ui-__helper_icon"};